<template>
  <div id="box5">
    <div class="box">
      <div class="box5-title">热门在线就业班</div>
      <div class="flex">
        <div
          class="item"
          v-for="(item, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :key="index"
        >
          <img
            :src="
              require(`../assets/box5/IT在线就业班-课程大纲-学习路线-教学服务-博学谷-${item}.png`)
            "
            alt=""
          />
          <div class="aaa">
            <span>VIP</span>
            <span>SVIP</span>
            <span style="width: 1.48rem">会员制</span>
          </div>
          <div class="txt">购课获小谷币<br />兑iPhone 12 Pro等好礼</div>
          <div class="btn" @click="Mai(item)">7天免费试学</div>
        </div>
        <div class="item">
          <img
            style="width: 100%; height: 100%;border-radius:0.13333rem;"
            src="../assets/any.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    Mai(e) {
      let name = "";
      switch (e) {
        case 9:
          name = "新综合实战电商";
          break;
        case 4:
          name = "新媒体+短视频运营";
          break;
        case 6:
          name = "软件测试";
          break;
        case 8:
          name = "产品经理";
          break;
        case 5:
          name = "UI/UE设计";
          break;
        case 7:
          name = "大数据进阶训练营";
          break;
        case 3:
          name = "前端与移动开发";
          break;
        case 2:
          name = "Python+人工智能";
          break;
        case 1:
          name = "JavaEE";
          break;
      }
      this.$mai(1, null, `七天免费试学(${name})`);
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 80px;
  width: 690px;
  height: 2382px;
  background-color: #6b00d9;
  .box5-title {
    margin: 0 auto;
    margin-top: 30px;
    width: 476px;
    height: 72px;
    background-color: #45008b;
    border-radius: 10px;
    text-align: center;
    font-family: SourceHanSansCN-Bold;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 72px;
    letter-spacing: 2px;
    color: #ffffff;
  }
  .flex {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    .item {
      overflow: hidden;
      margin-top: 30px;
      width: 310px;
      height: 420px;
      background-color: #9f7fff;
      border-radius: 10px;
      img {
        box-sizing: border-box;
        border-radius: 10px 10px 0 0;
        width: 100%;
        height: 190px;
        display: block;
        border: 1px solid #ffffff;
      }
      .aaa {
        display: flex;
        justify-content: space-around;
        flex-flow: row nowrap;
        margin-top: 16px;
        span {
          width: 73px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          display: block;
          border-radius: 17px;
          border: solid 2px #ffffff;
          font-family: SourceHanSansCN-Bold;
          font-size: 22px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #ffffff;
          // padding: 5px 10px;
        }
      }
      .txt {
        margin: 16px 0 0 10px;
        width: 279px;
        font-family: SourceHanSansCN-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #ffffff;
      }
      .btn {
        margin: 0 auto;
        margin-top: 10px;
        width: 260px;
        height: 66px;
        border-radius: 12px;
        background-image: url("../assets/btn.png");
        background-size: 100% 100%;
        text-align: center;
        font-family: SourceHanSansCN-Medium;
        font-size: 28px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 66px;
        letter-spacing: 1px;
        color: #5530fd;
        border: solid 2px #532bff;
      }
    }
  }
}
</style>